import L from "leaflet";
import * as _ from "lodash";

import { Light, MapSettings } from "@/models";
import { isNumericFlag } from "@/models/flag";

import collections from "./collections";

const FEETINMETER = 3.28084;

interface LuminaireElement {
    y1: number;
    y3: number;
    x1: number;
    x3: number;
    externalWidth?: string;
    externalLength?: string;
    reportingType?: string;
    luminaireType_ID: number;
    luminaireTypeDisplayName: string;
    BLEBeaconId?: string | number;
    tag: number;
    floorSpace_ID: number;
    [key: string]: unknown;
}

const converter = {
    convertMeterToFeet: (
        value: number | (number | string)[],
        precision = 2,
    ): number => {
        const numValue = Array.isArray(value) ? (value[0] as number) : value;
        const decimalConverter = Math.pow(10, precision);
        return (
            Math.round(numValue * FEETINMETER * decimalConverter) /
            decimalConverter
        );
    },
    convertFeetToMeters: (value: number | string, precision = 0): number => {
        const numValue = typeof value === "string" ? parseFloat(value) : value;
        const convertedValue = numValue / FEETINMETER;
        return precision > 0
            ? parseFloat(convertedValue.toFixed(precision))
            : convertedValue;
    },
    settings: {
        viewModelToAPI: (model: MapSettings) => model.convertToAPI(),
        APIToViewModel: (data: unknown) => new MapSettings(data),
    },
    lights: {
        viewModelToApi: (model: Light) => model.convertToAPI(),
        APIToViewModel: (element: LuminaireElement, positioningType = "") => {
            const d1 = L.latLng(element.y1 * -1, element.x1 * -1);
            const d3 = L.latLng(element.y3 * -1, element.x3 * -1);
            const point = L.latLngBounds(d1, d3).getCenter();
            const type = {
                width: element.externalWidth
                    ? converter.convertFeetToMeters(
                          parseFloat(element.externalWidth),
                      )
                    : Math.abs(element.x1 - element.x3),
                length: element.externalLength
                    ? converter.convertFeetToMeters(
                          parseFloat(element.externalLength),
                      )
                    : Math.abs(element.y1 - element.y3),
                isCLS: element.reportingType === "cls",
                id: element.luminaireType_ID,
                name: element.luminaireTypeDisplayName,
            };
            const options = {
                ...element,
                bleId: element.BLEBeaconId
                    ? element.BLEBeaconId.toString()
                    : "0",
                flags: collections.flags
                    .filter(isNumericFlag)
                    .filter((flag) => !!(element.tag & flag.value)),
                positioningType,
            };
            return new Light(point, type, element.floorSpace_ID, options);
        },
    },
};

export default converter;
